import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Fop from 'apps/fops/components/Fop';
import SectionType from 'apps/catalogue/models/SectionType';
import PerUnit from 'apps/catalogue/models/PerUnit';
import FopRibbon from 'apps/fops/components/FopRibbon';

export default class FopListItem extends Component {
  static propTypes = {
    className: PropTypes.string,
    collectionFopIdx: PropTypes.number,
    fop: PropTypes.shape({
      sku: PropTypes.string.isRequired,
      hash: PropTypes.number,
      fopAttributes: PropTypes.object,
    }),
    fopElementsFactory: PropTypes.shape({
      shouldUpdateFopControls: PropTypes.func.isRequired,
    }),
    fopType: PropTypes.string,
    hash: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    product: PropTypes.object,
    productsPageRoute: PropTypes.object.isRequired,
    section: PropTypes.shape({
      id: PropTypes.string.isRequired,
      attributes: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        type: PropTypes.oneOf(Object.keys(SectionType)),
        cluster: PropTypes.shape({
          tags: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string.isRequired,
              name: PropTypes.string.isRequired,
            })
          ),
          perUnit: PropTypes.oneOf(Object.keys(PerUnit)),
        }),
      }),
      fops: PropTypes.arrayOf(PropTypes.object).isRequired,
    }),
    sectionFopIdx: PropTypes.number,
    sectionIdx: PropTypes.number,
    sku: PropTypes.string,
    registerRef: PropTypes.func,
    pageParameters: PropTypes.object,
    sectionRibbonDisplayed: PropTypes.bool, // by default ribbons are not displayed
  };

  static placeholder = (<div className="fop-item" />);

  shouldComponentUpdate(nextProps) {
    return (
      this.props.product !== nextProps.product // NOSONAR
      || this.props.fop !== nextProps.fop
      || this.props.collectionFopIdx !== nextProps.collectionFopIdx
      || this.props.sectionFopIdx !== nextProps.sectionFopIdx
      || this.props.sectionIdx !== nextProps.sectionIdx
      || this.props.fopType !== nextProps.fopType
      || this.props.sectionRibbonDisplayed !== nextProps.sectionRibbonDisplayed
      || this.props.sku !== nextProps.sku
      || this.props.hash !== nextProps.hash
      || this.props.className !== nextProps.className
      || (this.props.fopElementsFactory &&
        this.props.fopElementsFactory.shouldUpdateFopControls(this.props.sku, nextProps.fopElementsFactory))
    );
  }

  componentWillUnmount() {
    this.updateRef(null);
  }

  updateRef = (ref) => {
    // clear the previous registration if any
    if (this.unregisterRef) {
      this.unregisterRef();
      this.unregisterRef = null;
    }

    // register new ref only if non-null given (null means removing component from DOM)
    const { sku, hash, registerRef } = this.props;
    if (ref && registerRef) {
      this.unregisterRef = registerRef(sku, hash, ref);
    }
  };

  generateFopElement() {
    if (!this.props.product) {
      return FopListItem.placeholder;
    }

    return (
      <Fop {...this.props} />
    );
  }

  generateRibbonElement() {
    const { section, sectionFopIdx, sectionRibbonDisplayed } = this.props;

    if (!sectionRibbonDisplayed || !section) {
      return null;
    }

    return (
      <FopRibbon
        sectionType={section.attributes.type}
        sectionTitle={section.attributes.title}
        cluster={section.attributes.cluster}
        customAttributes={section.attributes.custom}
        idx={sectionFopIdx}
        sectionLength={section.fops.length}
      />
    );
  }

  render() {
    const { section } = this.props;
    return (
      <li
        key={this.props.sku}
        className={classNames(
          'fops-item',
          section.attributes.type && `fops-item--${section.attributes.type.toLowerCase()}`,
        )}
        ref={this.updateRef}
      >
        {this.generateRibbonElement()}
        {this.generateFopElement()}
      </li>
    );
  }
}
